import classNames from 'classnames';
import { formatCurrencyGB } from 'helpers/formatNumber';
import FlexContainer from '../../../FlexContainer';
import Txt from '../../../Txt';
import styles from './PaymentSummary.module.scss';

/**
 * PaymentSummary
 *
 * @return {JSX.Element}
 */
const PaymentSummary = ({ className, reference, amount, frequency }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.PaymentSummary,
        className,
        PaymentSummary.displayName
      )}
      column
      gap
    >
      <FlexContainer column gapQuad>
        <Txt caption>AMOUNT</Txt>
        <Txt bold x>
          {formatCurrencyGB(amount)}
        </Txt>
      </FlexContainer>
      <FlexContainer column gapQuad>
        <Txt caption>FREQUENCY</Txt>
        <Txt bold x>
          {frequency}
        </Txt>
      </FlexContainer>
      <FlexContainer column gapQuad>
        <Txt caption>REFERENCE</Txt>
        <Txt bold x>
          {reference}
        </Txt>
      </FlexContainer>
    </FlexContainer>
  );
};

PaymentSummary.displayName = 'PaymentSummary';

export default PaymentSummary;
